import React from 'react';

import { TARIFF_TIME_UNIT_DAY, TARIFF_TIME_UNIT_MONTH, TARIFF_TIME_UNIT_YEAR } from 'src/util/constants';
import { getCurrencySymbol } from 'src/util/i18n/currency';
import buildValuePerTimeUnit from 'src/util/i18n/time/units';

/**
 * Return the standing charge details as a translated HTML string using the holistic approach.
 * This function now uses the complete rate expression formatting that handles proper
 * language structure for different locales.
 * @param {import('react-intl').IntlShape} intl - UI formatter for localized period text.
 * @param {import('react-intl').IntlShape} intlCurrency - Partner formatter for currency values.
 * @param {TARIFF_TIME_UNIT_DAY | TARIFF_TIME_UNIT_MONTH |
 *  TARIFF_TIME_UNIT_YEAR} timeUnit - The time unit for the rate (day, month, year)
 * @param {number} rate - The standing charge rate
 * @returns {React.ReactNode | null} Formatted rate expression
 */
const buildRate = (intl, intlCurrency, timeUnit, rate) => {
  if (!intl || !intlCurrency || !timeUnit || rate === undefined) {
    return null;
  }

  return buildValuePerTimeUnit(
    intl,
    intlCurrency,
    rate,
    getCurrencySymbol(intlCurrency),
    timeUnit,
  );
};

export default buildRate;
